import React from 'react'
import MegaNavbar from '../Components/MegaNavbar'
import './MOUS.css'
import 'aos/dist/aos.css';


import Table from 'react-bootstrap/Table';
import Footer from '../Components/Footer';

// import Archive from '../Components/Archive';

function MOUs() {
  return (
<>
<MegaNavbar/>

{/* <Archive/> */}

<div className="page-title ">
      <div className="heading bg-dark">
        <div className="fcontainer">
          <div className="row d-flex justify-content-center text-center ">
            <div className="col-lg-8 bg-dark">
              <h1>MOUs</h1>
              <p className="mb-0">
              Memoranda of Understanding (MOUs) are formal agreements between two or more parties outlining mutual goals and commitments, often used in business, government, or international relations to establish frameworks for cooperation and collaboration. They serve as non-binding documents that facilitate communication, partnership, and the exchange of resources or expertise. </p>
            </div>
          </div>
        </div>
      </div>
      <nav className="breadcrumbs bg-secondary">
        <div className="fcontainer">
          <ol>
            <li><a href="/">Home</a></li>
            <li className="current">MOUs</li>
          </ol>
        </div>
      </nav>
    </div>
      

<Table className='container mt-5 mb-5' striped bordered hover size="sm">
      <thead>
        <tr>
          <th>S.No</th>
          <th>Institute</th>
          <th>Date of Signing</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>Pakistan Academy of Environmental Sciences</td>
          <td>25-10-2023</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Peshawar High Court Bar Association</td>
          <td>19-10-2023</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Peshawar High Court Bar Association</td>
          <td>19-10-2023</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>3</td>
          <td>Sadabahar by Mrs. Tasneem Zahir Shah</td>
          <td>17-10-2023</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>4</td>
          <td>GIFT University, Gujranwala</td>
          <td>17-10-2023</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>5</td>
          <td>CIMS Foundation</td>
          <td>05-09-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>6</td>
          <td>Youth International Conclave </td>
          <td>19-10-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>7</td>
          <td>Dosti Welfare Organization</td>
          <td>08-09-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>8 </td>
          <td>Pakistan Institute of Legislative Development And Transparency (PILDAT)</td>
          <td>07-06-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>9</td>
          <td>Iftikhar Psychiatric Hospital</td>
          <td>17-05-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>10</td>
          <td>Universiti Sains Malaysia</td>
          <td>17-04-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>11  </td>
          <td>Directorate of Youth Affairs</td>
          <td>16-03-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>12</td>
          <td>Public Policy & Management Consultant, Peshawar</td>
          <td>19-10-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>13</td>
          <td>Al Hafiz Crystoplast Pvt. Ltd</td>
          <td>16-01-2023n</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>14</td>
          <td>Hunarmand Insight Pvt. Ltd</td>
          <td>16-01-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>15</td>
          <td>Khwendo Kor</td>
          <td>16-01-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>16</td>
          <td>Work to Empower</td>
          <td>16-01-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>17</td>
          <td>Human Care Foundation</td>
          <td>16-01-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>18</td>
          <td>Radio Pakistan</td>
          <td>16-01-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>19</td>
          <td>Enablers</td>
          <td>16-01-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>20</td>
          <td>Directorate of Law & Human Rights, Khyber Pakhtunkhwa</td>
          <td>16-01-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>21</td>
          <td>Federation of Pakistan chambers of Commerce & Industry (FPCCI)</td>
          <td>16-01-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>22</td>
          <td>Pakistan Institute of Living and Learning (PILL)</td>
          <td>16-01-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>23</td>
          <td>Women Chamber of Commerce and Industry Peshawar</td>
          <td>16-01-2023</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>24</td>
          <td>Lady Reading Hospital (LRH)</td>
          <td>01-09-2022</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>25</td>
          <td>Extreme Commerce (EC)</td>
          <td>16-08-2022</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>26</td>
          <td>Aryan Air Services Peshawar</td>
          <td>19-05-2022</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>27</td>
          <td>Socio Engineering Technologies Private Limited</td>
          <td>19-05-2022</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>28</td>
          <td>Alliance francaise d’ Islamabad, Islamabad (AFI)Enablers</td>
          <td>19-05-2022</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>29</td>
          <td>University of Punjab, Lahore</td>
          <td>16-01-2023</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>30</td>
          <td>Government College University, Lahore</td>
          <td>16-01-2023</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>31</td>
          <td>University of Peshawar (UOP)</td>
          <td>07.03.2022</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>32</td>
          <td>Shaukat Khanum Memorial Cancer Hospital and Research Centre</td>
          <td>07.03.2022</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>33</td>
          <td>Pakistan Development Foundation</td>
          <td>07.03.2022</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>34</td>
          <td>Association for Bio Risk Management</td>
          <td>07.03.2022</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>35</td>
          <td>Precision Medicine Lab</td>
          <td>07.03.2022</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>36</td>
          <td>Pakistan Agricultural Research Council (PARC)</td>
          <td>07.03.2022</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>37</td>
          <td>Centre for Peace and Development Initiatives (CPDI)</td>
          <td>07.03.2022</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>38</td>
          <td>Directorate of Archaeology & Museums</td>
          <td>07.03.2022</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>39</td>
          <td>Rawalpindi Chamber of Commerce (RCCI)</td>
          <td>09-01-2022</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>40</td>
          <td>The Bank of Khyber (BOK)</td>
          <td>02.12.2021</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>41</td>
          <td>Horizon Welfare, Peshawar, Pakistan</td>
          <td>02.12.2021</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>42</td>
          <td>Pakistan Study Centre , University of Peshawar</td>
          <td>02.12.2021</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>43</td>
          <td>National Incubation Centre (NIC)</td>
          <td>02.12.2021</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>44</td>
          <td>Engineering Research & IT Services Provider (Pvt) Ltd (ERISP)</td>
          <td>02.12.2021</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>45</td>
          <td>Consultreat</td>    
          <td>02.12.2021</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>46</td>
          <td>Center for Global and Strategic Studies, Islamabad.</td>
          <td>23.11.2021</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>47</td>
          <td>Institute of peace and Diplomatic Studies (IPDS)</td>
          <td>23.11.2021</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>48</td>
          <td>University of Birmingham</td>
          <td>01-11-2021</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>49</td>
          <td>Public Health Association KPK & FATA</td>
          <td>01.11.2021</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>50</td>
          <td>Power99 Foundation, Islamabad</td>
          <td>01.11.2021</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>51</td>
          <td>KPITB</td>
          <td>21.10.2021</td>
          <td>Active</td>
        </tr>
        
        <tr>
          <td>52</td>
          <td>FPCCI</td>
          <td>5.10.2021</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>53</td>
          <td>Fatmid Foundation</td>
          <td>30.09.2021</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>54</td>
          <td>Karakoram International University (KUI) Gilgit</td>
          <td>6.08.2021</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>55</td>
          <td>Pakistan Alliance for Early Childhood</td>
          <td>9.6.2021</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>56</td>
          <td>Quaid –e- Azam University, Islamabad</td>
          <td>22.6.2021</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>57</td>
          <td>Sehat Kahani</td>
          <td>11.3.2021</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>58</td>
          <td>Hannsidel foundation</td>
          <td>27.1.2021</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>59</td>
          <td>Institute for banking and finance</td>
          <td>2021</td>
          <td>Active</td>
        </tr>
        <tr>
          <td>60</td>
          <td>Khyber Pakhtunkhwa Commission on the Status of Women Pesahwar</td>
          <td>25.11.2020</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>61</td>
          <td>Pakistan Institute of Legislative Development and Transparency.</td>
          <td>30.01.2020</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>62</td>
          <td>National Incubation Center, Peshawar.</td>
          <td>19.02.2020</td>
          <td>Expired</td>
        </tr>
        
        <tr>
          <td>63</td>
          <td>Hassan Foundation</td>
          <td>29.09.2020</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>64</td>
          <td>Pink Pakistan Trust</td>
          <td>12.12.2020</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>65</td>
          <td>Council of Islamic Ideology, Islamabad, Pakistan.</td>
          <td>01.02.2019</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>66</td>
          <td>University Of Malakand ,Chakdara Dir Lower</td>
          <td>13.01.2019</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>67</td>
          <td>Institute of Peace and Diplomatic Studies, Islamabad, Pakistan.</td>
          <td>21.02.2019</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>68</td>
          <td>University of Science and Technology, Bannu.</td>
          <td>05.03.2019</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>69</td>
          <td>Shaoor Foundation for Education and Awareness (SEFA) Islamabad</td>
          <td>09.2019</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>70</td>
          <td>Pakistan Academy for Rural Development, Government of Pakistan Establishment Division.</td>
          <td>08.11.2019</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>71</td>
          <td>Tech Valley Pvt. Ltd. Abbotabad.</td>
          <td>14.11.2019</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>72</td>
          <td>Association for Biorisk Management-Pakistan.</td>
          <td>19.11.2019</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>73</td>
          <td>Worldwide Fund for Nature-Pakistan</td>
          <td>30.12.2019</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>74</td>
          <td>Center for Research and Security Studies, Islamabad.</td>
          <td>20.01.2018</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>75</td>
          <td>American Institute of Pakistan Studies</td>
          <td>3.01.2018</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>76</td>
          <td>Centre of Excellence for CPEC.</td>
          <td>27.02.2018</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>77</td>
          <td>Center for Social Education and Development.</td>
          <td>14.05.2018</td>
          <td>Expired</td> 
        </tr>
        <tr>
          <td>78</td>
          <td>Directorate of Higher Education, HED, Khyber Pakhtunkhwa-DHE.</td>
          <td>10.05.2018</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>79</td>
          <td>Shifa International Hospitals Ltd. Islamabad and Public Health Association, Khyber Pakhtunkhwa, Peshawar.</td>
          <td>24.10.2018</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>80</td>
          <td>Islamic Research Institute (IRI)International Islamic University(IIUI)</td>
          <td>2018</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>81</td>
          <td>Project Management Unit Higher Education Department(PMU)</td>
          <td> 24 .04.2018</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>82</td>
          <td>Directorate of Information Technology through Science Technology and Information Technology Department.</td>
          <td>21.09.2017</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>83</td>
          <td>Women Chamber of Commerce and Industry, Peshawar.</td>
          <td>27.04.2017</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>84</td>
          <td>Khyber Pakhtunkhwa Information Technology Board.</td>
          <td>11.04.2017</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>85</td>
          <td>Small and Medium Enterprises Development Authority (SMEDA), Pakistan.</td>
          <td>21.09.2017</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>86</td>
          <td>Liaison Corporation.</td>
          <td>21.09.2017</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>87</td>
          <td>Nuclear Institute for Food and Agriculture (NIFA).</td>
          <td>21.09.2017</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>88</td>
          <td>Sarhad Chamber of Commerce and Industry, </td>
          <td>03.03.2017</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>89</td>
          <td>National Institute of Historical and Cultural Research, Islamabad.</td>
          <td>15.03.2016</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>90</td>
          <td>Abdul Wali Khan University, Mardan.</td>
          <td>20.04.2016</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>91</td>
          <td>Sardar Bahadur Khan Women’s University, Quetta.</td>
          <td>09.05.2016</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>92</td>
          <td>Sarhad University of Science and Information Technology, Peshawar.</td>
          <td>27.07.2016</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>93</td>
          <td>Institute of Management Sciences (IMSciences), Peshawar.</td>
          <td>11.06.2015</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>94</td>
          <td>Sindh Madressatul Islam University, Karachi.</td>
          <td>14.06.2015</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>95</td>
          <td>Directorate of Archaeology and Museums, Govt. of Khyber Pakhtunkhwa, Peshawar.</td>
          <td>12.07.2015</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>96</td>
          <td>Women University of Azad Jammu and Kashmir, Bagh.</td>
          <td>27.08.2015</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>97</td>
          <td>Fatima Jinnah Women University, Rawalpindi.</td>
          <td>27.08.2015</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>98</td>
          <td>Government College Women University, Sialkot.</td>
          <td>27.08.2015</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>99</td>
          <td>Kinnaird College for Women, Lahore.</td>
          <td>27.08.2015</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>100</td>
          <td>Lahore College for Women University, Lahore.</td>
          <td>27.08.2015</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>101</td>
          <td>Government College Women University, Faisalabad.</td>
          <td>27.08.2015</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>102</td>
          <td>The Women University Multan.</td>
          <td>27.08.2015</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>103</td>
          <td>Ghulam Ishaq Khan Institute of Engineering Science and Technology, Pakistan.</td>
          <td>16.11.2015</td>
          <td>Expired</td>
        </tr>
        <tr>
          <td>104</td>
          <td>Directorate of Archives and Libraries, Govt. of Khyber Pakhtunkhwa, Peshawar.</td>
          <td>26.11.2015</td>
          <td>Expired</td>
        </tr>
      </tbody>
    </Table>
    <Footer/>
    </>
  );
}


export default MOUs;